import React from 'react';
import { NavLink } from 'react-router-dom';
import { withStyles, Typography } from './../../../themes/default';
import { Btn } from './../../../components/includes/ui';

import { Section, Content } from './../../../components/includes/container';

const styles = theme => ({
  root:  { display: 'flex', minHeight: '100%', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' },
  title: theme.typography.display2,
  text:  theme.typography.headline,
  subheading: theme.typography.subheading,
  button: { marginTop: theme.spacing.unit * 4 }
});

const Page404 = ({ classes, ...rest}) => {

  return (
    <Section>
      <Content>
        <div className={ classes.root }>
          <Typography component="h2" variant="display1" color="textPrimary">
            Error 404.
          </Typography>
          <Typography component="p" variant="display2" color="textSecondary">
            OOPS, página no encontrada!
          </Typography>
          <Typography component="p">
            It is possible that the address does not exist or that you do not have permission to access.
         </Typography>
         <div className={ classes.button }>
           <Btn component={ NavLink } to="/dashboard" color="primary" variant="contained">Continue</Btn>
         </div>
        </div>
      </Content>
    </Section>
  )

}

export default withStyles(styles)(Page404);
